module.exports = __webpack_public_path__ + "8e28053a670d3b1071e9c061b89e739a.png";